import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../../core/pagination/datatable";

import CommonFooter from "../../../../../core/common/footer/commonFooter";
import { Spin } from "antd";
import { ROLL_CALL_API_BASE_URL } from "../../RollCallConfig/RollCallConfig";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";
import { RotateCcw } from "feather-icons-react/build/IconComponents";

const RollcallEmployeeAccess = () => {
  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState([]);

  const [loadingStates, setLoadingStates] = useState({});
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const navigate = useNavigate();
  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });

  useEffect(() => {
    const raw = sessionStorage.getItem("rollcall-permissions");
    if (!raw) return;

    const permissions = JSON.parse(raw);

    // current route → "/rollcall/registrations"
    const currentRoute = window.location.pathname.replace("/", "");

    const pagePerm = permissions.find((p) => p.path === currentRoute);

    if (pagePerm) {
      setPerm({
        Read: pagePerm.Read,
        Write: pagePerm.Write,
        Delete: pagePerm.Delete,
        Export: pagePerm.Export,
      });
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchEmployeeData = async () => {
        setDataLoading(true);
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/emp/getEmployee?superid=${superIdData}&departmentid=&regid=`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );

          if (!response.ok) throw new Error("Failed to fetch employees");

          const data = await response.json();
          if (data.status) setData(data.ResultData || []);
          else console.error("Error fetching employees:", data.ErrorMsg);
        } catch (error) {
          console.error("Error fetching employees:", error);
        } finally {
          setDataLoading(false);
        }
      };

      fetchEmployeeData();
    }
  }, [tokenData, superIdData]);

  const handleCheckboxChange = async (regId, currentStatus, type) => {
    if (tokenData && superIdData) {
      const isRemoving = currentStatus;
      const apiUrl =
        type === "mobile"
          ? isRemoving
            ? `${ROLL_CALL_API_BASE_URL}portal/access/removemobileaccess`
            : `${ROLL_CALL_API_BASE_URL}portal/access/addmobileaccess`
          : isRemoving
          ? `${ROLL_CALL_API_BASE_URL}portal/access/removeempportalaccess`
          : `${ROLL_CALL_API_BASE_URL}portal/access/addempportalaccess`;

      const requestBody = { regid: regId };

      try {
        setLoadingStates((prev) => ({
          ...prev,
          [`${regId}_${type}`]: true,
        }));

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        console.log(data, "getting result data");

        setLoadingStates((prev) => ({
          ...prev,
          [`${regId}_${type}`]: false,
        }));

        if (data.status) {
          setData((prevData) =>
            prevData.map((item) =>
              item.regid === regId
                ? {
                    ...item,
                    [type === "mobile" ? "MobileAccess" : "EmpPortalAccess"]:
                      !currentStatus,
                  }
                : item
            )
          );
          Swal.fire({
            title: "Success",
            text: isRemoving
              ? `${
                  type === "mobile" ? "Mobile" : "Employee"
                } access removed successfully.`
              : `${
                  type === "mobile" ? "Mobile" : "Employee"
                } access granted successfully.`,
            icon: "success",
          }).then(() => window.location.reload());
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to process request.",
            icon: "error",
          });
        }
      } catch (error) {
        setLoadingStates((prev) => ({
          ...prev,
          [`${regId}_${type}`]: false,
        }));

        console.error("There was a problem with the fetch operation:", error);
        Swal.fire({
          title: "Error",
          text: "Something went wrong. Please try again.",
          icon: "error",
        });
      }
    }
  };

  const filteredData = data.filter((item) => {
    return (
      (item.UserName && item.UserName.toLowerCase()) ||
      (item.Badge && item.Badge.toLowerCase()) ||
      (item.Mobile && item.Mobile.toString()) ||
      (item.branchname && item.branchname.toLowerCase()) ||
      (item.Departmentname && item.Departmentname.toLowerCase())
    );
  });

  const handleDownloadExcel = () => {
    if (filteredData && filteredData.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = filteredData.map((item, index) => ({
      "S.No": index + 1,
      Name: item.UserName || "N/A",
      "Biometric ID": item.CardId || "N/A",
      Department: item.Departmentname || "N/A",
      "Mobile Access": item.MobileAccess ? "Yes" : "No",
      "Emp Portal Access": item.EmpPortalAccess ? "Yes" : "No",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Employee Access Data");
    XLSX.writeFile(wb, "Employee_Access_Data.xlsx");
  };

  const generatePDF = () => {
    if (filteredData && filteredData.length === 0) {
      return;
    }

    const doc = new jsPDF();
    doc.text("Employee Access Report", 14, 10);

    const tableColumn = [
      "S.No",
      "Name",
      "Biometric ID",
      "Department",
      "Mobile Access",
      "Emp Portal Access",
    ];
    const tableRows = filteredData.map((item, index) => [
      index + 1,
      item.UserName || "N/A",
      item.CardId || "N/A",
      item.Departmentname || "N/A",
      item.MobileAccess ? "Yes" : "No",
      item.EmpPortalAccess ? "Yes" : "No",
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save("Employee_Access_Data.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      sorter: (a, b) => a.sno - b.sno,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName.length - b.UserName.length,
      render: (text) => (
        <span title={text}>
          {text.length > 15 ? `${text.substring(0, 15)}...` : text}
        </span>
      ),
    },
    {
      title: "Biometric Id",
      dataIndex: "CardId",
      sorter: (a, b) => a.CardId.length - b.CardId.length,
    },
    {
      title: "Department",
      dataIndex: "Departmentname",
      sorter: (a, b) => a.Departmentname.length - b.Departmentname.length,
      render: (text) => (
        <span title={text}>
          {text.length > 15 ? `${text.substring(0, 15)}...` : text}
        </span>
      ),
    },
    {
      title: "Mobile Access",
      dataIndex: "MobileAccess",
      align: "center",
      render: (_, record) => (
        <div className="d-flex justify-content-center">
          {loadingStates[record.regid] ? (
            <Spin size="small" />
          ) : (
            <input
              type="checkbox"
              checked={record.MobileAccess}
              onChange={() =>
                handleCheckboxChange(
                  record.regid,
                  record.MobileAccess,
                  "mobile"
                )
              }
              style={{ cursor: "pointer" }}
              disabled={!perm?.Write}
            />
          )}
        </div>
      ),
    },
    {
      title: "Emp Portal Access",
      dataIndex: "EmpPortalAccess",
      align: "center",
      render: (_, record) => (
        <div className="d-flex justify-content-center">
          {loadingStates[record.regid] ? (
            <Spin size="small" />
          ) : (
            <input
              type="checkbox"
              checked={record.EmpPortalAccess}
              onChange={() =>
                handleCheckboxChange(
                  record.regid,
                  record.EmpPortalAccess,
                  "emp"
                )
              }
              style={{ cursor: "pointer" }}
              disabled={!perm?.Write}
            />
          )}
        </div>
      ),
    },
  ];

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/rollcall/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item">Employee Access</h4>
                </ol>
              </nav>
              <h6>Manage your employees access</h6>
            </div>
          </div>
          <ul className="table-top-head">
            {perm?.Export && (
              <>
                <li>
                  <OverlayTrigger placement="top" overlay={renderTooltip}>
                    <Link onClick={generatePDF}>
                      <ImageWithBasePath
                        src="assets/img/icons/pdf.svg"
                        alt="img"
                      />
                    </Link>
                  </OverlayTrigger>
                </li>
                <li>
                  <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                    <Link
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      onClick={handleDownloadExcel}
                    >
                      <ImageWithBasePath
                        src="assets/img/icons/excel.svg"
                        alt="img"
                      />
                    </Link>
                  </OverlayTrigger>
                </li>
              </>
            )}

            <li onClick={handleReload}>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>

        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between">
            <div className="search-set">
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="col-6 mb-2">
                  <label className="form-label"></label>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            {dataLoading ? (
              <div className="text-center my-4">
                <Spin size="large" />
                <p>Loading data...</p>
              </div>
            ) : (
              <Table columns={columns} dataSource={filteredData} />
            )}
          </div>
        </div>
      </div>
      <CommonFooter />
    </div>
  );
};

export default RollcallEmployeeAccess;
